import dayjs from 'dayjs';
import { TFnType } from '@tolgee/react';

export const renderStill = (t: TFnType, date: unknown, date2?: unknown) => {
  if (typeof date === 'string' || typeof date === 'number') {
    const day1 = dayjs(Number(date2) > 0 ? Number(date2) : undefined);
    const day2 = dayjs(Number(date));
    const duration = dayjs.duration(day1.diff(day2));
    const days = day1.diff(day2, 'days');
    const hours = duration.hours();
    const minutes = duration.minutes();
    return days === 0
      ? t(date2 ? '{y}小时{z}分钟' : '至今y小时z分钟', {
          y: hours,
          z: minutes,
        })
      : t(date2 ? '{x}天{y}小时{z}分钟' : '至今x天y小时z分钟', {
          x: days,
          y: hours,
          z: minutes,
        });
  } else {
    return '';
  }
};

export const getTodoStillTime = <
  T extends Pick<
    Todo.TodoInstance,
    'todoStatus' | 'orderTime' | 'type' | 'deliveryTime' | 'completedTime' | 'operateResult'
  >,
>(
  t: TFnType,
  todo: T,
) => {
  const { todoStatus, orderTime, type, deliveryTime, completedTime, operateResult } = todo;
  if (type === 9) {
    if (todoStatus === 3) {
      if (operateResult === 'DELIVERED') {
        return renderStill(t, orderTime, completedTime);
      }
    } else {
      return renderStill(t, orderTime);
    }
  }
  if (type === 10) {
    if (todoStatus === 3) {
      if (operateResult === 'COLLECTED') {
        return renderStill(t, orderTime, completedTime);
      }
    } else {
      return renderStill(t, orderTime);
    }
  }
  if (type === 11) {
    if (todoStatus === 3) {
      if (operateResult === 'REACHED') {
        return renderStill(t, deliveryTime, completedTime);
      }
    } else {
      return renderStill(t, deliveryTime);
    }
  }
  return '';
};
